import type { VoidFunctionComponent } from 'react';

type Props = {
  id: string;
  title?: string;
  prefix?: string;
};

const ItemizedRule: VoidFunctionComponent<Props> = ({
  id,
  title,
  prefix = '',
}) => {
  const displayId = `${prefix}${id}`;
  const lineItem = title ? `${displayId}: ${title}` : displayId;
  return <span>{lineItem}</span>;
};

export default ItemizedRule;
